import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { strengthVsWaterCementRatio } from '../../data/strength-vs-watercement-ratio';

@Component({
    selector: 'app-strength-chart',
    templateUrl: './strength-chart.component.html',
    styleUrls: ['./strength-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StrengthChartComponent implements OnInit {
  highlightY?: number;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    datasets: [
      {
        label: 'Compressive Strength - W/C Ratio',
        data: Object.entries(strengthVsWaterCementRatio).map(([x, y]: [string, number]) => ({ x: Number(x), y })),
        borderColor: '#dd3333',
        backgroundColor: '#dd3333',
        fill: false,
        tension: 0.1,
        pointRadius: 2,
        pointBackgroundColor: '#dd3333',
        borderWidth: 1
      }
    ]
  };

  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) => `strength(psi) ${tooltipItem.parsed.y}`
        },
        displayColors: false,
        backgroundColor: '#fff',
        titleColor: '#000',
        bodyColor: '#000',
        borderColor: '#ccc',
        borderWidth: 1,
        padding: 6,
        caretPadding: 4
      }
    },
    scales: {
      x: { type: 'linear', min: 0.4, max: 1.3 },
      y: { min: 0, max: 5500 }
    }
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.highlightY = this.data?.highlightY;

    // Update points if highlightY is provided
    if (this.highlightY !== undefined) {
      const dataset = this.lineChartData.datasets[0];
      dataset.pointBackgroundColor = dataset.data.map((point: any) =>
        point.y === this.highlightY ? 'red' : '#dd3333'
      );
      dataset.pointRadius = dataset.data.map((point: any) =>
        point.y === this.highlightY ? 5 : 2
      );
    }
  }
}
